import { camelCaseObjectToSnakeCase } from '../../utils/convert-case';

const normalizeCustomPalette = (palette) => {
  const { schemes, ...rest } = palette;

  if (!schemes) return rest;

  const normalizedSchemes = Object.fromEntries(
    Object.entries(schemes).map(([colorSchemeId, scheme]) => [
      colorSchemeId,
      {
        ...scheme,
        ...(scheme.variableOverrides && {
          variableOverrides: camelCaseObjectToSnakeCase(scheme.variableOverrides),
        }),
      },
    ])
  );

  return { ...rest, schemes: normalizedSchemes };
};

export default normalizeCustomPalette;
